/*
通过mutation间接更新state的多个方法的对象
 */

import { apiListPC } from '@/api'
import ajax from '@/api/ajax'

export default {
    // 同步记录用户信息
    // recordUser({commit}, userInfo) {
    //   commit(RECEIVE_USER_INFO, {userInfo})
    // },

    // 异步获取用户信息
    async getUserInfo({ commit }) {
        const res = await ajax(apiListPC.getUserInfo)
        const { nickname, phone, headImgUrl, openApplet } = res.data

        commit('userNameFun', { username: nickname, phone, avatar: headImgUrl, openApplet })
    },

    async storeGetClientele({ commit }, data = {}) {
        console.log(data)
        const paramsData = {
            license: data.license || sessionStorage.getItem('license'),
            type: data.type || '2',
        }
        ajax(apiListPC.getClientele, paramsData, 'GET').then((res) => {
            const displayName = res.systemName
            document.title = displayName

            const slogan = res.systemSlogan
            const imageAddress = res.imageAddress != null ? res.imageAddress : ''
            const clienteleName = res.clienteleName != null ? res.clienteleName : ''
            const appImageAddress = res.appImageAddress != null ? res.appImageAddress : ''
            const watermark = res.watermark != null ? res.watermark : ''
            const themeColor = res.themeColor != null ? res.themeColor : ''

            commit('saveClientele', {
                displayName,
                slogan,
                imageAddress,
                clienteleName,
                appImageAddress,
                watermark,
                themeColor,
                appletName: res.appletName,
            })
        })
    },
    // // 异步登出
    // async logout({commit}) {
    //   const result = await reqLogout()
    //   if (result.code === 0) {
    //     commit(RESET_USER_INFO)
    //   }
    // },
}
